// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"a3-z","dimensionLabel":"b3-z","styleChooserControlWrapper":"c3-z","styleChooserControl":"d3-z","disabled":"e3-z","giftCard":"f3-z","styleChooserText":"g3-z"};